import { useMemo } from 'react'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import { UseUserMenuProps } from './_props'
import { MenuEntrie } from '../components/feature/header/_props'
import useUserPermissions from './useUserPermissions'
import { useHelpCenterDialogContext } from '../context/HelpCenterDialogContext'

export const useUserMenu = ({ helpCenterUrl, iconClass }: UseUserMenuProps): MenuEntrie[] => {
    const { hasUserPermission } = useUserPermissions()
    const isAdmin = hasUserPermission('ADMIN')
    const { openHelp } = useHelpCenterDialogContext()

    return useMemo(() => {
        const adminOnly = (label: string, to: string) => ({
            label,
            to,
            hidden: !isAdmin,
        })

        return [
            {
                title: 'Compte',
                options: [
                    { label: 'Mon compte', to: '/me' },
                    { label: 'Gestion sécurité', to: '/security' },
                ],
            },
            {
                title: 'Établissement',
                options: [
                    adminOnly('Gérer les utilisateurs', '/users'),
                    { label: 'Gérer les requérants de téléexpertise', to: '/requesters' },
                    { label: 'Gérer les téléconsultants', to: '/network'},
                    adminOnly('Gérer les correspondants', '/contacts'),
                    adminOnly('Modifier les informations et courriels', '/establishment'),
                    adminOnly('Paramétrer les préférences', '/preferences'),
                ],
            },
            {
                title: 'Aide',
                options: [
                    {
                        label: "Centre d'aide et de tutoriels",
                        to: helpCenterUrl,
                        icon: <ArrowOutwardIcon className={iconClass} />,
                    },
                    { label: "Besoin d'assistance", action: openHelp },
                ],
            },
            {
                title: 'Informations',
                options: [
                    { label: 'À propos', to: '/about' },
                    { label: 'CGU', to: '/cgu' },
                    { label: 'Mentions légales', to: '/legal' },
                ],
            },
        ]
    }, [isAdmin, helpCenterUrl, iconClass])
}
